import { makeStyles } from '@material-ui/core';
import { useEffect } from 'react';
import { useFieldArray } from 'react-hook-form';

export const usePassengersForm = () => {
  const {
    fields: passengerFields,
    append: passengerAppend,
    remove: passengerRemove,
  } = useFieldArray({
    name: 'item.passengers',
  });

  const useStyles = makeStyles((theme) => {
    return {
      underline: {
        '&.Mui-error:after': {
          borderBottomColor: `${theme.palette.error.main} !important`,
        },
      },
    };
  });

  const classes = useStyles();

  useEffect(() => {
    if (passengerFields.length === 0) passengerAppend({ documentNumber: '' });
  }, [passengerFields]);

  return { passengerFields, passengerAppend, passengerRemove, classes };
};
